/* eslint-disable no-extend-native */
// support flatMap syntax below chrome 69
if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function <T, U>(
        this: T[],
        callback: (value: T, index: number, array: T[]) => U | readonly U[],
        thisArg?: any,
    ): U[] {
        if (typeof callback !== 'function') {
            throw new TypeError(`${callback} is not a function`)
        }

        return this.map((element, index, array) => {
            return callback.call(thisArg, element, index, array)
        }).reduce<U[]>((acc, val) => {
            if (Array.isArray(val)) {
                return acc.concat(val as U[])
            }
            return acc.concat([val as U])
        }, [])
    }
}
